// extracted by mini-css-extract-plugin
export default {"desc":"OverView_desc__Nx0HE","highLights":"OverView_highLights__3h+pp","requirements":"OverView_requirements__r-r0z","audience":"OverView_audience__Ntp9p"};